import { useQuery } from '@tanstack/react-query'
import { useAuth0 } from '@/utils/auth/auth0'
import * as API from '../../api/iwiAPI'

export function useIwi(token: string) {
  const { getAccessTokenSilently } = useAuth0()

  const query = useQuery({
    queryKey: ['iwi'],
    queryFn: async () => {
      const freshToken = await getAccessTokenSilently()
      return API.fetchIwi(freshToken)
    },
    enabled: !!token,
    retry: 3,
  })

  return {
    iwi: Array.isArray(query.data) ? query.data : undefined,
    isLoading: query.isLoading,
    isError: query.isError,
    errorMessage: query.error?.message,
  }
}
